var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-badge",attrs:{"title":"Affiliate stage"}},[_vm._v(" ENTHUSIAST")])}
var staticRenderFns = []

export { render, staticRenderFns }